/* istanbul ignore file */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IServicesOffering } from 'src/app/model/sitefinity/IServicesOffering';

@Component({
  selector: 'app-tech-services-card',
  templateUrl: './tech-services-card.component.html',
  styleUrls: ['./tech-services-card.component.scss']
})
export class TechServicesCardComponent{
  @Input() techServiceCardData: IServicesOffering;
  @Output() openModal = new EventEmitter();
}
